import { Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import ToolTipComponent from '../../components/GlobalComponents/ToolTipComponent';

export const renderCommentToolTip = (comment) => {
    const cleanComment = DOMPurify.sanitize(comment, {
        ALLOWED_TAGS: ['b', 'u', 'i', 'em', 'strong'],
    });
    if (!comment) return null;

    return (
        <ToolTipComponent
            disableFocusListener
            enterTouchDelay={150}
            placement="right"
            title={
                !comment || comment === '' || comment === 'No Comments' ? null : (
                    <Typography
                        variant="string"
                        dangerouslySetInnerHTML={{ __html: cleanComment }}
                    />
                )
            }
        >
            <Typography
                sx={{
                    maxWidth: '100%',
                    display: 'inline-block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
                variant="body2"
                component="span"
                dangerouslySetInnerHTML={{ __html: cleanComment }}
            />
        </ToolTipComponent>
    );
};

export default renderCommentToolTip;
